import Vue from 'vue';
import GlobalMixin from '@/mixins/global.mixin';

Vue.mixin(GlobalMixin);
